import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class RevertReservationsStatusService {
  private readonly API_ENDPOINT = 'oc-api/operations/reservations/bulk-status-change';

  constructor(private http: HttpClient) {}

  uploadFile(email: string, file: File) {
    const formData: FormData = new FormData();
    formData.append('email', new Blob([email], { type: 'text/plain' }));
    formData.append('file', file, file.name);

    return this.http.post(this.API_ENDPOINT, formData);
  }
}



// WEBPACK FOOTER //
// ./src/app/merchants/revert-status/revert-reservations-status.service.ts